/**
 * Serializes data table column state from specified column definitions.
 * This is required to save some characters before URL codification.
 * As a result, we prevent exceding browsers' max URL Bytes.
 * @param {object} state - Data table state to be serialized
 * @param {object} columnDefs - Columns definition object
 * @returns {string} Table column state serialized
 */
export function serialize (state, columnDefs) {
  return state.map(
    ({ colId, hide, sort, sortIndex, rowGroup, rowGroupIndex }) => [
      colId,
      Number(hide),
      sort === null ? -1 : Number(sort === 'asc'),
      sortIndex === null ? -1 : sortIndex,
      rowGroup ? 1 : -1,
      rowGroupIndex ?? -1
    ].join()
  ).join('|')
}

/**
 * Deserializes a string to build a data table columns state.
 * Retrieves information from columns definition as columns id, sorting configuration
 * and if column is visible.
 * @param {string} state - Data table state serialized
 * @param {object} columnDefs - Columns definition object to help deserialize string
 * @returns {object} Table column state as a configuration object
 */
export function deserialize (state, columnDefs) {
  return state.split('|').map(item => {
    const [colId, hide, sort, sortIndex, rowGroup, rowGroupIndex] = item.split(',')
    const rowColIndex = Number(rowGroupIndex)
    return {
      colId,
      hide: hide === '1',
      sort: sort === '-1' ? null : sort === '1' ? 'asc' : 'desc',
      sortIndex: sortIndex === '-1' ? null : Number(sortIndex),
      rowGroup: rowGroup === '1',
      rowGroupIndex: rowColIndex > -1 ? rowColIndex : null
    }
  })
}

export default {
  serialize,
  deserialize
}
